import * as actionTypes from './actionsTypes';

export const setFavouriteCustomers = (favouriteCustomers) => {
  return {
    type: actionTypes.SETFAVOURITECUSTOMERS,
    data: favouriteCustomers,
  };
};
